import React from "react";
import { InlineMath } from "react-katex";
import Row from "./Row";

const DesktopHelp = () => {
  return (
    <div className="w-full pt-4 gap-y-2 w-full relative m-auto grid grid-cols-1 gap-y-2">
      <Row
        left={<h2 className="text-md font-semibold ">Keyword</h2>}
        right={<h2 className="text-md font-semibold ">Symbol </h2>}
      />
      <Row
        left={
          <>
            <kbd className="kbd w-max">all</kbd>
            <kbd className="kbd w-max">(</kbd>
          </>
        }
        right={<kbd className="kbd w-max">(</kbd>}
      />

      <Row
        left={
          <>
            <kbd className="kbd w-max">and</kbd>
            <kbd className="kbd w-max">then</kbd>
            <kbd className="kbd w-max">)</kbd>
          </>
        }
        right={<kbd className="kbd w-max">)</kbd>}
      />

      <Row
        left={
          <>
            <kbd className="kbd w-max">square root of x</kbd>
            <kbd className="kbd w-max">square root x</kbd>
            <kbd className="kbd w-max">sqrt x</kbd>
          </>
        }
        right={
          <kbd className="kbd w-max">
            <InlineMath math={"\\sqrt{x}"} />
          </kbd>
        }
      />
      <Row
        left={
          <>
            <kbd className="kbd w-max">x squared</kbd>
            <kbd className="kbd w-max">x^2</kbd>
          </>
        }
        right={
          <kbd className="kbd w-max">
            <InlineMath math={"x^2"} />
          </kbd>
        }
      />
      <Row
        left={
          <>
            <kbd className="kbd w-max">x cubed</kbd>
            <kbd className="kbd w-max">x^3</kbd>
          </>
        }
        right={
          <kbd className="kbd w-max">
            <InlineMath math={"x^{3}"} />
          </kbd>
        }
      />
      <Row
        left={
          <>
            <kbd className="kbd w-max">x to the power of y</kbd>
            <kbd className="kbd w-max">x^y</kbd>
          </>
        }
        right={
          <kbd className="kbd w-max">
            <InlineMath math={"x^{y}"} />
          </kbd>
        }
      />
      <Row
        left={
          <>
            <kbd className="kbd w-max">natural log of x</kbd>
            <kbd className="kbd w-max">ln x</kbd>
          </>
        }
        right={
          <kbd className="kbd w-max">
            <InlineMath math={"\\ln\\left(x\\right)"} />
          </kbd>
        }
      />
      <Row
        left={
          <>
            <kbd className="kbd w-max">integral from x to y of dtheta</kbd>
            <kbd className="kbd w-max">integral from x to y dtheta</kbd>
          </>
        }
        right={
          <kbd className="kbd w-max">
            <InlineMath math={"\\int_x^{y} dθ"} />
          </kbd>
        }
      />
      <Row
        left={
          <>
            <kbd className="kbd w-max">derivative of tangent of theta</kbd>
          </>
        }
        right={
          <kbd className="kbd w-max">
            <InlineMath math={"\\frac{d}{dx} \\tan\\left(\\theta\\right)"} />
          </kbd>
        }
      />
      <Row
        left={
          <>
            <kbd className="kbd w-max">tangent of theta</kbd>
            <kbd className="kbd w-max">tan theta</kbd>
            <kbd className="kbd w-max">tan(theta)</kbd>
          </>
        }
        right={
          <kbd className="kbd w-max">
            <InlineMath math={"\\tan\\left(\\theta\\right)"} />
          </kbd>
        }
      />
      <Row
        left={
          <>
            <kbd className="kbd w-max">sin of theta</kbd>
            <kbd className="kbd w-max">sin theta</kbd>
            <kbd className="kbd w-max">sin(theta)</kbd>
          </>
        }
        right={
          <kbd className="kbd w-max">
            <InlineMath math={"\\sin\\left(\\theta\\right)"} />
          </kbd>
        }
      />
      <Row
        left={
          <>
            <kbd className="kbd w-max">cos of theta</kbd>
            <kbd className="kbd w-max">cos theta</kbd>
            <kbd className="kbd w-max">cos(theta)</kbd>
          </>
        }
        right={
          <kbd className="kbd w-max">
            <InlineMath math={"\\cos\\left(\\theta\\right)"} />
          </kbd>
        }
      />
      <Row
        left={
          <>
            <kbd className="kbd w-max">cotangent of theta</kbd>
            <kbd className="kbd w-max">cot theta</kbd>
            <kbd className="kbd w-max">cot(theta)</kbd>
          </>
        }
        right={
          <kbd className="kbd w-max">
            <InlineMath math={"\\frac{1}{\\tan\\left(\\theta\\right)}"} />
          </kbd>
        }
      />
      <Row
        left={
          <>
            <kbd className="kbd w-max">cosecant of theta</kbd>
            <kbd className="kbd w-max">csc theta</kbd>
            <kbd className="kbd w-max">csc(theta)</kbd>
          </>
        }
        right={
          <kbd className="kbd w-max">
            <InlineMath math={"\\frac{1}{\\sin\\left(\\theta\\right)}"} />
          </kbd>
        }
      />
      <Row
        left={
          <>
            <kbd className="kbd w-max">secant of theta</kbd>
            <kbd className="kbd w-max">sec theta</kbd>
            <kbd className="kbd w-max">sec(theta)</kbd>
          </>
        }
        right={
          <kbd className="kbd w-max">
            <InlineMath math={"\\frac{1}{\\cos\\left(\\theta\\right)}"} />
          </kbd>
        }
      />

      <Row
        left={
          <>
            <kbd className="kbd w-max">x over x</kbd>
            <kbd className="kbd w-max">x downstairs y</kbd>
            <kbd className="kbd w-max">x divided by y</kbd>
            <kbd className="kbd w-max">x/y</kbd>
          </>
        }
        right={
          <kbd className="kbd w-max">
            <InlineMath math={"\\frac{x}{y}"} />
          </kbd>
        }
      />
      <Row
        left={
          <>
            <kbd className="kbd w-max">pi multiplied by r </kbd>
            <kbd className="kbd w-max">pi times r</kbd>
            <kbd className="kbd w-max">pi*r</kbd>
          </>
        }
        right={
          <kbd className="kbd w-max">
            <InlineMath math={"\\pi r"} />
          </kbd>
        }
      />
      <Row
        left={
          <>
            <kbd className="kbd w-max">x plus y</kbd>
            <kbd className="kbd w-max">x+y</kbd>
          </>
        }
        right={
          <kbd className="kbd w-max">
            <InlineMath math={"x+y"} />
          </kbd>
        }
      />
      <Row
        left={
          <>
            <kbd className="kbd w-max">x minus y</kbd>
            <kbd className="kbd w-max">x-y</kbd>
          </>
        }
        right={
          <kbd className="kbd w-max">
            <InlineMath math={"x-y"} />
          </kbd>
        }
      />
      <Row
        left={
          <>
            <kbd className="kbd w-max">equals</kbd>
            <kbd className="kbd w-max">=</kbd>
          </>
        }
        right={
          <kbd className="kbd w-max">
            <InlineMath math={"="} />
          </kbd>
        }
      />
    </div>
  );
};

export default DesktopHelp;
